import React from "react";
import connectp from "../../assets/images/connect.svg";

import AuthHeader from "./AuthHeader";
import Authfooter from "./Authfooter";

const ConnetPayment = () => {
  return (
    <div className="main-layout_auth">
      <AuthHeader />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="text-center">
              <img alt='' src={connectp} className="img-otp" />
              <h4 className="auth_heading">Connect to Payment Gateway</h4>
              <p className="auth_subhead">
                You have successfully verified the account.
              </p>
              <a href="/" className="btn text-white  btn-primary">
                Connect
              </a>
            </div>
          </div>
        </div>
      </div>
      <Authfooter />
    </div>
  );
};

export default ConnetPayment;
